module.exports = __webpack_public_path__ + "static/media/4. Windri.af539ea1.png";